export default "__VITE_ASSET__Dv$GiXXY__"